<template>
  <el-dialog :visible.sync="couponVisible" @close='closeDialog' width="720px">
    <div slot="title" class="header-title">
      <span class="name">管理优惠码({{ promo_code_data.nickname }})</span>
    </div>
    <el-table
      :data="promo_code_data.promo_code_data"
      border
      style="width: 100%">
      <el-table-column
        label="优惠码"
        width="180">
        <template slot-scope="scope">
          <div v-if="!scope.row.is_free_code">{{ scope.row.code_num }}</div>
          <el-button v-else type="primary" @click="getFreeCode(scope.row)" plain>下载码包</el-button>
        </template>
      </el-table-column>
      <el-table-column
        label="团长版价格"
        width="180">
        <template slot-scope="scope">
          <div>￥{{ scope.row.seller_price }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="品牌商版价格"
        width="180">
        <template slot-scope="scope">
          <div>￥{{ scope.row.brander_price }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-popover
            placement="top"
            width="160"
            v-model="scope.row.visible">
            <p>确定要删除此优惠码吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button type="text" size="mini" @click="scope.row.visible = false">取消</el-button>
              <el-button type="primary" size="mini" @click="handleDelete(scope.row)">确定</el-button>
            </div>
            <el-button type="danger" slot="reference">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <div class="add-promo-code">
      <div style="width:180px"></div>
      <el-input style="width:180px" v-model="sellerPrice" placeholder="￥399"></el-input>
      <el-input style="width:180px" v-model="branderPrice" placeholder="￥899"></el-input>
      <el-button
          size="small"
          type="primary"
          style="margin-left:10px;"
          @click="addPromoCode">添加</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CouponCode',
  props: {
    couponshow: {
      type: Boolean,
      required: true
    },
    promo_code_data: {
      type: Object,
      required: true
    },
    client_id: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      deletePromoCodeURL: this.getDomain() + 'bmagent/delete_promo_code',
      addPromoCodeURL: this.getDomain() + 'bmagent/add_promo_code',
      getFreeCodeURL: this.getDomain() + 'bmagent/get_free_code',
      sellerPrice: undefined,
      branderPrice: undefined,
      len: undefined
    }
  },
  computed: {
    couponVisible: {
      get () {
        return this.couponshow
      },
      set (val) {
        this.$emit('update:couponshow', val)
      }
    }
  },
  methods: {
    handleDelete (row) {
      let params = {
        code_id: row.code_id
      }
      let handle = res => {
        this.$emit('getPromoCode', this.client_id)
      }
      this.__axios(this.deletePromoCodeURL, params, handle)
    },
    addPromoCode () {
      if (!this.sellerPrice || !this.branderPrice) {
        this.$message.error('请输入价格')
      } else {
        let params = {
          client_id: this.client_id,
          seller_price: Math.round(this.sellerPrice * 10 * 10),
          brander_price: Math.round(this.branderPrice * 10 * 10)
        }
        let handle = res => {
          this.$emit('getPromoCode', this.client_id)
        }
        this.__axios(this.addPromoCodeURL, params, handle)
      }
    },
    getFreeCode (row) {
      let params = {
        client_id: this.client_id,
        pack_count: row.pack_count
      }
      let handle = res => {
        window.open(res.data.content.url)
      }
      this.__axios(this.getFreeCodeURL, params, handle)
    },
    closeDialog () {
      this.sellerPrice = ''
      this.branderPrice = ''
    }
  }
}
</script>

<style scoped>

  .add-promo-code {
    display: flex;
    align-items: center;
    height: 45px;
  }

  .padding {
    padding: 10px;
  }

  .width-200 {
    width: 200px;
  }
</style>
